import { render, staticRenderFns } from "./PointListProductLayout.vue?vue&type=template&id=7b36f906&scoped=true&"
import script from "./PointListProductLayout.vue?vue&type=script&lang=js&"
export * from "./PointListProductLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b36f906",
  null
  
)

export default component.exports